import ClaimForm from './ClaimForm';

export default ClaimForm;
